export default "__VITE_ASSET__BBIpTMjy__";